import { FunctionComponent, useState } from 'react'
import { AddToCartCollapsedButtonProps } from './AddToCartCollapsedButton.types'
import { useMealActions } from 'src/hooks/coreUx/useMealActions'
import { ReactComponent as TrashIcon } from 'src/assets/icons/trash-icon.svg'
import { ReactComponent as MinusIcon } from 'src/assets/icons/minus-icon.svg'
import { ReactComponent as PlusIcon } from 'src/assets/icons/plus-icon.svg'
import './AddToCartCollapsedButton.scss'

export const AddToCartCollapsedButton: FunctionComponent<AddToCartCollapsedButtonProps> = ({
  attributes,
  product
}) => {
  const mealActionsProps = useMealActions(
    product,
    attributes.actions.onAdd,
    attributes.actions.onRemove
  )
  const [isStepperVisible, setIsStepperVisible] = useState(
    (mealActionsProps.quantity ?? 0) > 0
  )

  const handleAddClick = () => {
    mealActionsProps.add()
    setIsStepperVisible(true)
  }

  const handleRemoveClick = () => {
    if (mealActionsProps.quantity === 1) {
      setIsStepperVisible(false)
    }
    mealActionsProps.remove()
  }

  const quantity = mealActionsProps.quantity ?? 0

  return (
    <div
      className="core-ux-add-to-cart-collapsed-button"
      role="toolbar"
      aria-label="Add to cart actions"
      onKeyDown={e => {
        if (e.key === 'Escape') {
          setIsStepperVisible(false)
        }
      }}
      tabIndex={-1}>
      {quantity === 0 && !isStepperVisible ? (
        <button
          id="add-to-cart-button"
          className="core-ux-add-to-cart-collapsed-button__button"
          onClick={handleAddClick}
          disabled={
            mealActionsProps.disableAllButtons ||
            mealActionsProps.reachedPlanSize
          }
          aria-label="Add item to cart"
          tabIndex={0}>
          <PlusIcon className="core-ux-add-to-cart-collapsed-button__button-icon" />
        </button>
      ) : (
        <>
          <button
            className="core-ux-add-to-cart-collapsed-button__button"
            onClick={handleRemoveClick}
            aria-label="Remove item from cart"
            tabIndex={0}>
            {quantity === 1 ? (
              <TrashIcon className="core-ux-add-to-cart-collapsed-button__button-icon" />
            ) : (
              <MinusIcon className="core-ux-add-to-cart-collapsed-button__button-icon" />
            )}
          </button>
          <span className="core-ux-add-to-cart-collapsed-button__quantity">
            {quantity}
          </span>
          <button
            className="core-ux-add-to-cart-collapsed-button__button"
            onClick={handleAddClick}
            aria-label="Add item to cart"
            tabIndex={0}>
            <PlusIcon className="core-ux-add-to-cart-collapsed-button__button-icon" />
          </button>
        </>
      )}
    </div>
  )
}
